import * as googleIcons from './icons_google';
import {
  HappyInbox as SVGHappyInbox,
  LaptopRobot as SVGLaptopRobot,
} from './icons_svg_legacy';
import { useSelector } from 'react-redux';
import { getFeatureFlag, Feature } from '../../models/features/features';
import Icon from './icon';

/**
 * @fileoverview
 * @deprecated These icon components are deprecated and should not be used in new code.
 * Please use the Icon components from @socialchorus/shared-ui-components instead.
 *
 * Legacy Note: When possible, use the Icon component directly
 * This class serves to enable feature-flagged legacy-logic to deliver old icons
 * New components should use the default Icon behaviour (Material Symbols)
 *
 */

export const Globe = (props) => {
  return googleIcons.Globe(props);
};

export const Inbox = (props) => {
  return googleIcons.Inbox(props);
};

export const Chat = (props) => {
  return googleIcons.Chat(props);
};

export const Notifications = (props) => {
  return googleIcons.Notifications(props);
};

export const Compass = (props) => {
  return googleIcons.Compass(props);
};

export const LightBulb = (props) => {
  return googleIcons.LightBulb(props);
};

export const AssistantIcon = (props) => {
  const assistantCompassMode = useSelector((state) =>
    getFeatureFlag(state, Feature.ASSISTANT_ICON_IS_COMPASS)
  );
  return assistantCompassMode ? (
    <Compass style={{ fontSize: '32px' }} {...props} />
  ) : (
    <LightBulb className="filled" {...props} />
  );
};

export const DiscoverIcon = (props) => {
  const assistantCompassMode = useSelector((state) =>
    getFeatureFlag(state, Feature.ASSISTANT_ICON_IS_COMPASS)
  );
  //opposite of assistant
  return !assistantCompassMode ? (
    <Compass {...props} />
  ) : (
    <LightBulb className="filled" {...props} />
  );
};

export const HappyInbox = (props) => {
  return <SVGHappyInbox {...props} />;
};

export const Shield = (props) => {
  return googleIcons.Shield(props);
};

export const LaptopRobot = (props) => {
  return <SVGLaptopRobot {...props} />;
};

export const Profile = (props) => {
  return googleIcons.Profile(props);
};

export const SideBarProfileIcon = (props) => {
  return googleIcons.SideBarProfileIcon(props);
};

export const ChevronRight = (props) => {
  return googleIcons.ChevronRight(props);
};

export const ChevronLeft = (props) => {
  return googleIcons.ChevronLeft(props);
};

export const VideoIcon = (props) => {
  return googleIcons.VideoIcon(props);
};

export const VideoPostIcon = (props) => {
  return googleIcons.VideoPostIcon(props);
};

export const ImageIcon = (props) => {
  return googleIcons.ImageIcon(props);
};

export const NoteIcon = (props) => {
  return googleIcons.NoteIcon(props);
};

export const ArticleIcon = (props) => {
  return googleIcons.ArticleIcon(props);
};

export const LinkIcon = (props) => {
  return googleIcons.LinkIcon(props);
};

export const FeaturedIcon = (props) => {
  return googleIcons.FeaturedIcon(props);
};

export const StarFeaturedIcon = (props) => {
  return googleIcons.StarFeaturedIcon(props);
};

export const TrendingIcon = (props) => {
  return googleIcons.TrendingIcon(props);
};

export const SwitchIcon = (props) => {
  return googleIcons.SwitchIcon(props);
};

export const BookmarkIcon = (props) => {
  return googleIcons.BookmarkIcon(props);
};

export const BookmarkedIcon = (props) => {
  return googleIcons.BookmarkedIcon(props);
};

export const PostIcon = (props) => {
  return googleIcons.PostIcon(props);
};

export const ChannelsIcon = (props) => {
  return googleIcons.ChannelsIcon(props);
};

export const EditProfileIcon = (props) => {
  return googleIcons.EditProfileIcon(props);
};

export const ResetPasswordIcon = (props) => {
  return googleIcons.ResetPasswordIcon(props);
};

export const ShareIcon = (props) => {
  return googleIcons.ShareIcon(props);
};

export const SubmitCommentIcon = (props) => {
  return googleIcons.SubmitCommentIcon(props);
};

export const PersonIcon = (props) => {
  return googleIcons.PersonIcon(props);
};

export const LatestIcon = (props) => {
  return googleIcons.LatestIcon(props);
};

export const ResourcesIcon = (props) => {
  return googleIcons.ResourcesIcon(props);
};

export const InviteIcon = (props) => {
  return googleIcons.InviteIcon(props);
};

export const HomeIcon = (props) => {
  return googleIcons.HomeIcon(props);
};

export const JoinedChannelsIcon = (props) => {
  return googleIcons.JoinedChannelsIcon(props);
};

export const JoinChannelsIcon = (props) => {
  return googleIcons.JoinChannelsIcon(props);
};

export const LikeIcon = (props) => {
  return <Icon type="thumb_up" className="no-animation filled" {...props} />;
};

export const LikeIconOutline = (props) => {
  return <Icon type="thumb_up" className="no-animation" {...props} />;
};

export const SettingsIcon = (props) => {
  return googleIcons.SettingsIcon(props);
};

export const NewContentIcon = (props) => {
  return googleIcons.NewContentIcon(props);
};

export const VideoPlayIcon = (props) => {
  return googleIcons.VideoPlayIcon(props);
};

export const GroupIcon = (props) => {
  return googleIcons.GroupIcon(props);
};
